import {
  ApiMasterDataBatchAdvancedQueryResponse,
  ApiMasterDataBatchAdvancedQueryResponseItem,
  ApiMasterDataQuery,
} from '../api/api-interfaces';
import { CachedMasterDataService } from '../api/cached-master-data-service';
import { BenchmarkConfig } from '../api/master-data-service';
import { DataTypes } from '../constants/constants';
import { VersionId } from '../v2/api/types';
import {
  advancedQueryToCustomSqlQuery,
  oldQueryToAdvancedQuery,
} from './utils';

export const GetResponseForQueriesService = async (
  queries: ApiMasterDataQuery[],
  latestVersions: Partial<Record<DataTypes, VersionId>>,
  cachedMasterDataApiService: CachedMasterDataService,
  benchmarkConfig?: BenchmarkConfig
): Promise<ApiMasterDataBatchAdvancedQueryResponse> => {
  return Promise.all(
    queries.map(async (q) => {
      const advancedQuery = oldQueryToAdvancedQuery(
        q,
        latestVersions[q.dataType as DataTypes]
      );
      const sqlQuery = await advancedQueryToCustomSqlQuery(advancedQuery);
      const result = await cachedMasterDataApiService.executeCustomSqlQuery(
        advancedQuery.dimensions ?? [],
        advancedQuery.measures ?? [],
        sqlQuery,
        advancedQuery.disableNestLoop
      );
      return {
        query: advancedQuery,
        response: result,
      } as ApiMasterDataBatchAdvancedQueryResponseItem;
    })
  ).then((responses) => {
    return { responseListItems: responses };
  });
};
